// extracted by mini-css-extract-plugin
module.exports = {"contactDealer":"_7a639804","contactDealerLabel":"_4e60cbe2","phoneIcon":"_3bf50c88"};